const menuButton = document.querySelector("[data-vayn-menu-button]");
const menu = document.querySelector("[data-vayn-menu]");

if (menuButton && menu) {
  menuButton.addEventListener("click", () => {
    const isOpen = menu.classList.toggle("is-open");
    menuButton.setAttribute("aria-expanded", String(isOpen));
  });
}

document.querySelectorAll("[data-vayn-product-section]").forEach((section) => {
  const filterButtons = section.querySelectorAll("[data-filter]");
  const productCards = section.querySelectorAll("[data-category]");

  filterButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const filter = button.dataset.filter;

      filterButtons.forEach((item) => item.classList.remove("is-active"));
      button.classList.add("is-active");

      productCards.forEach((card) => {
        const isVisible = filter === "all" || card.dataset.category === filter;
        card.hidden = !isVisible;
      });
    });
  });
});

document.querySelectorAll("[data-vayn-product-gallery]").forEach((gallery) => {
  const mediaItems = gallery.querySelectorAll("[data-vayn-product-media]");
  const dots = gallery.querySelectorAll("[data-vayn-product-dot]");
  const prevButton = gallery.querySelector("[data-vayn-product-prev]");
  const nextButton = gallery.querySelector("[data-vayn-product-next]");
  let activeIndex = 0;

  if (!mediaItems.length) return;

  function setMedia(index) {
    activeIndex = (index + mediaItems.length) % mediaItems.length;
    mediaItems.forEach((item, itemIndex) => {
      item.classList.toggle("is-active", itemIndex === activeIndex);
    });
    dots.forEach((dot, dotIndex) => {
      dot.classList.toggle("is-active", dotIndex === activeIndex);
    });
  }

  dots.forEach((dot, index) => {
    dot.addEventListener("click", () => setMedia(index));
  });

  prevButton?.addEventListener("click", () => setMedia(activeIndex - 1));
  nextButton?.addEventListener("click", () => setMedia(activeIndex + 1));
});
